import { Enemy } from "./Enemy";
import { Container } from "pixi.js";
import { Textures } from "./Textures";
import { Grappler } from "./behaviours/Grappler";
import { TrackingBulletPattern, StationaryRanged, RadialBulletPattern } from "./behaviours/StationaryRanged";

export class Enemies {
	public static createTutorialSpider(parent: Container, stage: number, x: number, y: number) {
		const enemy = this.createSpider(parent, stage, x, y);
		enemy.speed = 0;
		(enemy.behaviour as StationaryRanged).minDistance = 100;
		(enemy.behaviour as StationaryRanged).maxDistance = 100000;
		((enemy.behaviour as StationaryRanged).pattern as TrackingBulletPattern).maxCount= 1;
		return enemy;
	}

	public static createTutorialBird(parent: Container, stage: number, x: number, y: number) {
		const enemy = this.createBird(parent, stage, x, y);
		enemy.speed *= 0.8;
		return enemy;
	}

	public static createSpider(parent: Container, stage: number, x: number, y: number): Enemy {
		let stationaryRanged = new StationaryRanged();
		stationaryRanged.bulletSize = 3;
		stationaryRanged.bulletSpeed = 0.25;
		let pattern = new TrackingBulletPattern();
		stationaryRanged.pattern = pattern;
		stationaryRanged.fireOnSight = false;
		const enemy = new Enemy(parent, Textures.spider, stationaryRanged);
		enemy.container.x = x;
		enemy.container.y = y;
		enemy.speed = 0.1;
		enemy.health = 6;
		if (stage == 2) enemy.health = 12;
		if (stage == 3) enemy.health = 24;
		enemy.size = 20;
		enemy.preferredSpacing = 200;
		enemy.damage = 1;
		return enemy;
	}

	public static createSnake(parent: Container, stage: number, x: number, y: number): Enemy {
		let stationaryRanged = new StationaryRanged();
		stationaryRanged.bulletSize = 3;
		stationaryRanged.bulletSpeed = 0.20;
		let pattern = new RadialBulletPattern();
		pattern.count = 8;
		stationaryRanged.pattern = pattern;
		stationaryRanged.fireOnSight = false;
		const enemy = new Enemy(parent, Textures.snake, stationaryRanged);
		enemy.container.x = x;
		enemy.container.y = y;
		enemy.speed = 0.1;
		enemy.health = 10;
		if (stage == 2) enemy.health = 14;
		if (stage == 3) enemy.health = 18;
		enemy.size = 20;
		enemy.damage = 1;
		enemy.preferredSpacing = 100;
		return enemy;
	}

	public static createBird(parent: Container, stage: number, x: number, y: number): Enemy {
		const enemy = new Enemy(parent, Textures.bird, new Grappler());
		enemy.container.x = x;
		enemy.container.y = y;
		enemy.speed = 0.18;
		enemy.health = 20;
		if (stage == 2) enemy.health = 30;
		if (stage == 3) enemy.health = 40;
		enemy.size = 15;
		enemy.preferredSpacing = 100;
		enemy.damage = 1;
		enemy.isGrounded = false;
		return enemy;
	}
}
